import React, { useRef, useEffect } from 'react';
import ContentEditable from 'react-contenteditable';
import './RichTextEditor.css';

const RichTextEditor = ({ value, onChange, placeholder, disabled, error }) => {
  const editorRef = useRef(null);

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  const execCommand = (command, value = null) => {
    document.execCommand(command, false, value);
    if (editorRef.current?.el?.current) {
      editorRef.current.el.current.focus();
    }
  };


  return (
    <div className={`rich-text-editor ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}>
      <div className="rich-text-toolbar">
        <button
          type="button"
          onClick={() => execCommand('bold')}
          className="toolbar-btn"
          title="Bold"
          disabled={disabled}
        >
          <strong>B</strong>
        </button>
        <button
          type="button"
          onClick={() => execCommand('italic')}
          className="toolbar-btn"
          title="Italic"
          disabled={disabled}
        >
          <em>I</em>
        </button>
        <button
          type="button"
          onClick={() => execCommand('underline')}
          className="toolbar-btn"
          title="Underline"
          disabled={disabled}
        >
          <u>U</u>
        </button>
        <div className="toolbar-separator"></div>
        <button
          type="button"
          onClick={() => execCommand('justifyLeft')}
          className="toolbar-btn"
          title="Align Left"
          disabled={disabled}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="21" y1="10" x2="7" y2="10"></line>
            <line x1="21" y1="6" x2="3" y2="6"></line>
            <line x1="21" y1="14" x2="3" y2="14"></line>
            <line x1="21" y1="18" x2="7" y2="18"></line>
          </svg>
        </button>
        <button
          type="button"
          onClick={() => execCommand('justifyCenter')}
          className="toolbar-btn"
          title="Align Center"
          disabled={disabled}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="10" x2="6" y2="10"></line>
            <line x1="21" y1="6" x2="3" y2="6"></line>
            <line x1="21" y1="14" x2="3" y2="14"></line>
            <line x1="18" y1="18" x2="6" y2="18"></line>
          </svg>
        </button>
        <button
          type="button"
          onClick={() => execCommand('justifyRight')}
          className="toolbar-btn"
          title="Align Right"
          disabled={disabled}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="10" x2="17" y2="10"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="14" x2="21" y2="14"></line>
            <line x1="3" y1="18" x2="17" y2="18"></line>
          </svg>
        </button>
        <div className="toolbar-separator"></div>
        <button
          type="button"
          onClick={() => execCommand('insertUnorderedList')}
          className="toolbar-btn"
          title="Bullet List"
          disabled={disabled}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="9" cy="12" r="1"></circle>
            <circle cx="9" cy="5" r="1"></circle>
            <circle cx="9" cy="19" r="1"></circle>
            <line x1="20" y1="12" x2="12" y2="12"></line>
            <line x1="20" y1="5" x2="12" y2="5"></line>
            <line x1="20" y1="19" x2="12" y2="19"></line>
          </svg>
        </button>
        <button
          type="button"
          onClick={() => execCommand('insertOrderedList')}
          className="toolbar-btn"
          title="Numbered List"
          disabled={disabled}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="10" y1="6" x2="21" y2="6"></line>
            <line x1="10" y1="12" x2="21" y2="12"></line>
            <line x1="10" y1="18" x2="21" y2="18"></line>
            <line x1="4" y1="6" x2="4" y2="6" strokeWidth="3"></line>
            <line x1="4" y1="12" x2="4" y2="12" strokeWidth="3"></line>
            <line x1="4" y1="18" x2="4" y2="18" strokeWidth="3"></line>
          </svg>
        </button>
        <div className="toolbar-separator"></div>
        <button
          type="button"
          onClick={() => execCommand('removeFormat')}
          className="toolbar-btn"
          title="Remove Formatting"
          disabled={disabled}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
            <line x1="12" y1="2" x2="12" y2="22"></line>
            <line x1="2" y1="12" x2="22" y2="12"></line>
          </svg>
        </button>
      </div>
      <ContentEditable
        innerRef={editorRef}
        html={value || ''}
        onChange={handleChange}
        disabled={disabled}
        className="rich-text-content"
        data-placeholder={placeholder}
      />
    </div>
  );
};

export default RichTextEditor;

